import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'
import MapMixin from 'js/mixins/map.js'
import VueBarMixin from 'js/mixins/vue-bar.js'
import {buildPlannerOperatorOptions} from 'js/lib/planner/search-form'
import SidepanelMixin from './_sidepanel-mixin'
import RouteItem from './_route-item'
import SidepanelSelectedRoute from './_sidepanel-selected-route'
import PlannerMap from './_planner-map'
import SearchDirectionsForm from './_search-directions-form'
import template from './index.pug'

import TopologyStopsService from 'js/services/api/topology/stops.js'
import SearchDirectionService from 'js/services/api/search-direction/search-direction'
import { executeGoToPlanner } from 'js/services/planner/go-to-planner'
import NewSearchDirectionsForm from 'js/pages/planner/direction-internal-result/_new-search-directions-form'
import BikeLogo from 'assets/images/valenbisiLogoModal.svg'
import { getPlannerMapLayoutVariant, PLANNER_MAP_LAYOUT_VARIANTS } from 'js/config/planner'
import {
  buildPlannerBikeOperator,
  buildPlannerBikeStopsToAdd,
  buildPlannerMapDirectionSelection,
  buildPlannerStopFavoritesParams,
  buildPlannerStopsLoadOptions,
  filterPlannerStopsByOperatorRoutes,
  formatPlannerMapCoordinates,
  formatPlannerPhotonAddress,
  formatPlannerStopName,
  getPlannerRouteErrorKey,
  getSelectedPlannerMapOperators,
  isPlannerBikeOperatorSelected,
  managePlannerStops,
  removeDuplicatePlannerOperators,
  shouldUsePlannerBikeStops,
  sortPlannerRoutes
} from 'js/lib/planner/direction-result'
const VL = 'vl'

export default Vue.extend({
  name: 'planner-results-index',
  template: template(),
  components: {
    RouteItem,
    SidepanelSelectedRoute,
    PlannerMap,
    SearchDirectionsForm,
    NewSearchDirectionsForm

  },
  mixins: [MapMixin, VueBarMixin, SidepanelMixin],
  data() {
    return {
      routes: null,
      selectedRoute: null,
      searchError: null,
      pointerPosition: {},
      stops: [],
      stopsAllOperators: [],
      bikeStops: [],
      bikeStopsToAdd: [],
      activePointsMap: {},
      currentWaypoints: '',
      favoritesStops: [],
      noRoutesAvailable: false,
      showErrorMessage: '',
      localOperators: [],
      formatDirection: '',
      configMapInit: {
        geo: {
          lat: '',
          lng: ''
        },
        stops_map_zoom: 0,
        stops_map_radio:0
      },
      searchDirectionOnMap: {
        input: '',
        direction: '',
        cordenate : {
          lat: '',
          lng: ''
        }
      },
      latitude: '',
      longitude: '',
      directionsSelected: '',
      hiddeTooltips: false,
    }
  },
  computed: {
    ...mapGetters('appConfig', [
      'planner_router_url',
      'planner_router_reverse_url'
    ]),
    ...mapGetters([
      'userPosition',
      'operators',
      'getPlannerSelectedOperators'
    ]),

    operatorOptions() {
      return buildPlannerOperatorOptions(this.localOperators, this.getPlannerSelectedOperators)
    },

    selectedMapOperators() {
      return getSelectedPlannerMapOperators(
        this.localOperators,
        this.operatorOptions,
        this.getPlannerSelectedOperators
      )
    },

    plannerMapStops() {
      const operatorStops = filterPlannerStopsByOperatorRoutes(
        this.stops,
        this.selectedMapOperators
      )
      const bikeStops = isPlannerBikeOperatorSelected(
        this.getPlannerSelectedOperators,
        this.operatorOptions
      ) ? this.bikeStopsToAdd : []

      return [...operatorStops, ...bikeStops]
    },

    isValencia() {
      return this.currentAppConfig.code === 'vl' 
    },

    isMurcia() {
      return this.currentAppConfig.code === 'mr' 
    },

    isGc() {
      return this.currentAppConfig.code === 'gc' 
    },

    useExtendedPlannerLayout() {
      const layoutVariant = getPlannerMapLayoutVariant(this.currentAppConfig.code)

      return layoutVariant === PLANNER_MAP_LAYOUT_VARIANTS.EXTENDED
    },

    plannerMotor() {
      return this.currentAppConfig.planner_motor
    },

    plannerRouter() {
      return this.planner_router
    },

    plannerBasemap() {
      return this.currentAppConfig.planner_basemap
    },

    plannerBasemapUrl() {
      return this.currentAppConfig.planner_basemap_url
    },

    isRouteSelected() {
      return !!this.selectedRoute
    },
    formattedSearchErrorMessage() {
      return this.$t('planner.searchErrorHtml', this.searchError)
    }
  },
  watch: {
    routes(value) {
      this.$nextTick(() => {
        if (value.length && this.$refs.sidepanel) {
          const scrollPadding = 8
          const container = this.$refs.sidepanel.$el.querySelector('.vb-content')
          const itemsContainer = this.$refs.plannerItems
          const finalScrollPosition = itemsContainer.offsetTop - scrollPadding

          container.scrollTo({top: finalScrollPosition, behavior: 'smooth'})
        }
      })
    },
    operators: {
      handler(newOperators) {
        this.localOperators = this.removeDuplicateOperators(newOperators);
      },
      immediate: true
    },
    $municipality: {
      handler(value) {
        const { geo, stops_map_zoom, stops_map_radio } = value
        this.configMapInit = { geo, stops_map_zoom, stops_map_radio }
        if (value) {
          this.setMunicipalityConfig(value)
        }
      },
      immediate: true
    },
    pointerPosition: {
      handler() {
        this.loadData()
      },
      immediate: true
    },
    currentUser: {
      handler(newUser, oldUser) {
        if (newUser !== oldUser) {
          this.getStopFavorites();
        }
      },
      immediate: true
    }
  },
  
  methods: {
    ...mapActions(['getOperators']),

    resetMapPosition() {
      if (this.configMapInit) {
        const { geo, stops_map_zoom } = this.configMapInit
        this.map.setView([geo.lat, geo.lng], stops_map_zoom)
      }
    },

    async getStopFavorites() {
      if (!this.currentUser) { return }

      const params = buildPlannerStopFavoritesParams(Vue.store.state.municipality.id)

      const response = await TopologyStopsService.favorites({ params, skipLoading: true })
      this.favoritesStops = this.manageStops(response)
    },

    async goToPlanner(plannerData) {
      Vue.store.commit('incrementLoading'); // Indicador de carga

      try {
        const result = await executeGoToPlanner(plannerData, {
          determineErrorMessage: (error, allRoutes) => this.determineErrorMessage(error, allRoutes),
          onPlannerStateReset: () => Vue.store.commit('resetPlannerState'),
          sortRoutes: routes => this.sortRoutes(routes),
          translate: key => this.$t(key)
        })

        this.routes = result.routes
        this.noRoutesAvailable = result.noRoutesAvailable
        if (result.showErrorMessage !== undefined) {
          this.showErrorMessage = result.showErrorMessage
        }
      } catch (error) {
        Vue.store.commit('resetPlannerState');
        this.noRoutesAvailable = true;
      } finally {
        Vue.store.commit('decreaseLoading');
      }
    },
    onRoutes(routes) {
      this.routes = routes
    },
    onSearchError(searchError) {
      this.searchError = searchError
    },

    selectRoute(route) {
      if(this.isMurcia || this.isValencia || this.isGc){
        this.$store.commit('setPlannerRoute', route)
      }
      this.selectedRoute = route
      this.resetSidepanelScroll()
    },

    hideRoute() {
      this.selectedRoute = null
      if (this.isMurcia || this.isValencia || this.isGc) {
        this.setMunicipalityConfig(this.configMapInit)
        this.reloadStops()
      }
    },

    reloadStops() {
      this.filteredStops = this.filterStopsByOperatorRoutes()
      this.stopsAllOperators = [...this.stops, ...this.bikeStopsToAdd]
    },

    async initializePage() {
      if (!this.currentAppConfig || Object.keys(this.currentAppConfig).length === 0) {
        await this.$store.dispatch('appConfig/loadAppConfig');
      }
      if (this.currentAppConfig && Object.keys(this.currentAppConfig).length > 0) {
        await this.loadData();
      } else {
        console.error('No se pudo cargar la configuración de la app.');
      }
    },
    reloadPosition(newPosition) {
      this.pointerPosition = newPosition
      this.loadData()
    },

    async loadData() {
      if (!this.$municipality.administrative_area_id) { return }
      const options = buildPlannerStopsLoadOptions(this.$municipality, this.pointerPosition, this.distance)
      await TopologyStopsService.nearests(options, true).then(response => {
        this.stopsLoading = false
        this.stops = this.manageStops(response.data)
      })

      await this.getOperators();

      this.localOperators = this.removeDuplicateOperators(this.operators);

      if (this.currentAppConfig.code === VL) {
        await this.getBikes();
        this.addValnbiciToOperator();
      }

      await this.processBikeStops();

      await this.getStopFavorites();
    },

    async getBikes() {
      try {
        const response = await TopologyStopsService.bikes(this.currentAppConfig.id);
        if (shouldUsePlannerBikeStops(this.currentAppConfig)) {
          this.bikeStops = response.stations;
        } else {
          this.bikeStops = []
        }
      } catch (error) {
        this.bikeStops = []
      }
    },

    addValnbiciToOperator() {
      if (this.bikeStops.length > 0) {
        this.operators.push(buildPlannerBikeOperator(BikeLogo));
      }
    },

    processBikeStops() {
      this.bikeStopsToAdd = buildPlannerBikeStopsToAdd(
        this.operators,
        this.bikeStops,
        BikeLogo,
        name => this.formatName(name)
      )
      this.stopsAllOperators = [...this.stops, ...this.bikeStopsToAdd];

      this.filteredStops = this.filterStopsByOperatorRoutes();
    },

    filterStopsByOperatorRoutes() {
      return filterPlannerStopsByOperatorRoutes(this.stopsAllOperators, this.operators)
    },

    formatName(name) {
      return formatPlannerStopName(name)
    },

    setMunicipalityConfig(municipality) {
      this.pointerPosition = municipality.geo
      this.zoom = municipality.stops_map_zoom
      this.distance = municipality.stops_map_radio
    },

    manageStops(stops) {
      return managePlannerStops(stops)
    },

    handleActivePointsMap(value) {
      this.activePointsMap = value
      this.currentWaypoints = this.activePointsMap.currentWaypoints
    },

    handleCurrentWaypoints(value) {
      this.currentWaypoints = value
    },

    determineErrorMessage(error, allRoutes) {
      return this.$t(getPlannerRouteErrorKey(error, allRoutes))
    },

    removeDuplicateOperators(operators) {
      return removeDuplicatePlannerOperators(operators)
    },

    async setActivePointMap(cordenate) {
      this.latitude = cordenate.lat
      this.longitude = cordenate.lng

      await this.getAddressFromCoordinates(this.latitude, this.longitude)

    },

    async getAddressFromCoordinates(lat, lng) {
      const params = {
        url: this.planner_router_reverse_url,
        lat: this.latitude,
        lng: this.longitude
      }

      try {
        // Este servicio me retorna la direccion para un par de coordenadas
        const response = await SearchDirectionService.getDirectionLatLng(params)
        const properties = response.body.features[0]?.properties

        // Manejo de la estructura de la respuesta.
        // Para el type house or street
        this.directionsSelected = formatPlannerPhotonAddress(properties) || formatPlannerMapCoordinates(lat, lng)

      } catch (error) {
        this.formatDirection = ''
        this.directionsSelected = formatPlannerMapCoordinates(lat, lng)

        // Falta agregar el manejo en caso de que no encuentre la direccion
        // notificacion?
      }
    },

    setDirectionsForm() {
      this.formatDirection = this.directionsSelected;
      this.searchDirectionOnMap = buildPlannerMapDirectionSelection(
        this.currentWaypoints,
        this.formatDirection,
        this.latitude,
        this.longitude
      )
    },


    sortRoutes(routes) {
      return sortPlannerRoutes(routes)
    }
  }
})
